export default __webpack_public_path__ + "41dae93191ef5750c97f15530ab2cb2d.pdf";